import type { OpenWindowState } from './types';
import { OpenTableAction } from './types';

export const ACTIVE_TABLE_CHANNEL_NAME = 'active-game-channel';
export const ACTIVE_TABLE_WINDOW_NAME = 'ActiveTable';

export function isTableWindowActive() {
  const activeTableWindow = localStorage.getItem(ACTIVE_TABLE_WINDOW_NAME);
  return !!activeTableWindow;
}

export function setTableWindowActive() {
  localStorage.setItem(ACTIVE_TABLE_WINDOW_NAME, 'true');
}

export function setTableWindowInctive() {
  localStorage.removeItem(ACTIVE_TABLE_WINDOW_NAME);
}

export function openOrFocusTab(url: string): OpenWindowState {
  const isActive = isTableWindowActive();
  const win: Window | null = window.open('', ACTIVE_TABLE_WINDOW_NAME);
  const result: OpenWindowState = {
    win,
    action: OpenTableAction.FOCUS
  };

  if (win?.location.href === 'about:blank') {
    if (isActive) {
      win?.close();
      result.action = OpenTableAction.ALREADY_ACTIVE;
    } else {
      win.location.href = url;
      result.action = OpenTableAction.OPEN;
    }
  }

  return result;
}
